<script lang="ts">
	import type { PostFiltersSchema } from '$src/utils/api/feed.util';
	import InputMain from '$lib/components/common/inputs/textInputs/GlobalTextInput.svelte';
	import { parseRangeUserInput } from '$utils/helpers.util';
	import { onMount } from 'svelte';

  export let detail: PostFiltersSchema['seedsReceived'] = {};
  export let isValid: boolean;

  let _seedsRange: string;

  let forceValid = false;

  if ((detail.minSeeds ?? null !== null) || (detail.maxSeeds ?? null !== null)) {
    _seedsRange =
      (detail.minSeeds?.toString() || '0') + ' - ' + (detail.maxSeeds?.toString() || '');

    forceValid = true;
  }

  $: parsed = parseRangeUserInput(_seedsRange);

  $: isValid = parsed !== null;

  $: if (parsed?.min) detail.minSeeds = parsed.min;
  $: if (parsed?.max) detail.maxSeeds = parsed.max;

  $: captionPart =
    parsed?.min || parsed?.max ? ` (min: ${parsed?.min || 0}, max: ${parsed.max || '♾️'})` : '';

  onMount(() => {
    if (forceValid) {
      isValid = true;
    }
  });
</script>

<InputMain
  label="Seeds received"
  bind:value={_seedsRange}
  caption="Range of seeds received{captionPart}"
  danger={!isValid}
  dangerMessage="Try a range such as 10 - 20"
/>
